"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaboratorySample = exports.LaboratorySampleStatusIcons = void 0;
const obejct_diff_1 = require("../utils/obejct-diff");
const network_constants_1 = require("./network.constants");
exports.LaboratorySampleStatusIcons = {
    erfasst: 'erfasst',
    unbekannt: 'unbekannt',
    ohneBefund: 'ohneBefund',
    positiverBefund: 'positiverBefund'
};
class LaboratorySample {
    constructor(additionalContext, districts) {
        this.context = undefined;
        this.districts = undefined;
        this.createdByUserId = undefined;
        this.identifier = undefined;
        this.contextId = undefined;
        this.currentLocation = undefined;
        this.currentLocationTitle = undefined;
        this.gameRecordId = undefined;
        this.huntingDistrictId = undefined;
        this.huntingDistrictName = undefined;
        this.materialID = undefined;
        this.result = undefined;
        this.status = undefined;
        this.statusTitle = undefined;
        this.type = undefined;
        this.typeTitle = undefined;
        this.comment = undefined;
        this.creationDate = undefined;
        this.updateTimestamp = undefined;
        this.examinations = undefined;
        this.hiTierState = undefined;
        this.hiTierError = undefined;
        this.hiTierErrorCode = undefined;
        this.nvState = undefined;
        this.nvError = undefined;
        this.nvErrorCode = undefined;
        this.context = additionalContext;
        this.districts = districts;
    }
    setFromAny(element) {
        const { identifier, contextId, currentLocation, createdByUserId, currentLocationTitle, gameRecordId, huntingDistrictId, huntingDistrictName, materialID, result, status, statusTitle, type, typeTitle, comment, creationDate, updateTimestamp, examinations, hiTierState, hiTierError, hiTierErrorCode, nvState, nvError, nvErrorCode } = element;
        // set if only ids are set ...
        if (!typeTitle && this.type)
            this.typeTitle = this.getTypeTitle();
        if (!statusTitle && this.status)
            this.statusTitle = this.getStatusTitle();
        if (!currentLocationTitle && this.currentLocation)
            this.currentLocationTitle = this.getLocationTitle();
        this.createdByUserId = createdByUserId ? createdByUserId : this.createdByUserId;
        this.identifier = identifier ? identifier : this.identifier;
        this.contextId = contextId ? contextId : this.contextId;
        this.currentLocation = currentLocation ? currentLocation : this.currentLocation;
        this.currentLocationTitle = currentLocationTitle ? currentLocationTitle : this.currentLocationTitle;
        this.gameRecordId = gameRecordId ? gameRecordId : this.gameRecordId;
        this.huntingDistrictId = huntingDistrictId ? huntingDistrictId : this.huntingDistrictId;
        this.huntingDistrictName = huntingDistrictName ? huntingDistrictName : this.huntingDistrictName;
        this.materialID = materialID ? materialID : this.materialID;
        this.result = result ? result : this.result;
        this.status = status ? status : this.status;
        this.statusTitle = statusTitle ? statusTitle : this.statusTitle;
        this.type = type ? type : this.type;
        this.typeTitle = typeTitle ? typeTitle : this.typeTitle;
        this.comment = comment ? comment : this.comment;
        this.creationDate = creationDate ? (0, obejct_diff_1.isDate)(creationDate) ? creationDate : (0, obejct_diff_1.firestoreTimestampToDate)(creationDate) : this.creationDate;
        this.updateTimestamp = updateTimestamp ? (0, obejct_diff_1.isDate)(updateTimestamp) ? updateTimestamp : (0, obejct_diff_1.firestoreTimestampToDate)(updateTimestamp) : this.updateTimestamp;
        this.examinations = examinations ? examinations : this.examinations;
        this.hiTierState = hiTierState ? hiTierState : this.hiTierState;
        this.hiTierError = hiTierError ? hiTierError : this.hiTierError;
        this.hiTierErrorCode = hiTierErrorCode ? hiTierErrorCode : this.hiTierErrorCode;
        this.nvState = nvState ? nvState : this.nvState;
        this.nvError = nvError ? nvError : this.nvError;
        this.nvErrorCode = nvErrorCode ? nvErrorCode : this.nvErrorCode;
    }
    getStatusTitle() {
        var _a;
        if (this.statusTitle)
            return this.statusTitle;
        if (!this.status)
            return undefined;
        const settingRef = network_constants_1.NetworkConstants.SETTING_LAB_SAMPLE_STATUS;
        const setting = (_a = this.context) === null || _a === void 0 ? void 0 : _a.settingsMap.get(settingRef);
        if (!this.context || !setting)
            return this.status ? this.status : undefined;
        const quality = setting.values.find(el => el.identifier == this.status);
        if (!quality)
            return this.status ? this.status : undefined;
        return quality.title ? quality.title : this.status ? this.status : undefined;
    }
    getLocationTitle() {
        var _a;
        if (this.currentLocationTitle)
            return this.currentLocationTitle;
        if (!this.currentLocation)
            return undefined;
        const settingRef = network_constants_1.NetworkConstants.SETTING_LAB_SAMPLE_LOCATION;
        const setting = (_a = this.context) === null || _a === void 0 ? void 0 : _a.settingsMap.get(settingRef);
        if (!this.context || !setting)
            return this.currentLocation ? this.currentLocation : undefined;
        const quality = setting.values.find(el => el.identifier == this.currentLocation);
        if (!quality)
            return this.currentLocation ? this.currentLocation : undefined;
        return quality.title ? quality.title : this.currentLocation ? this.currentLocation : undefined;
    }
    getTypeTitle() {
        var _a;
        if (this.typeTitle)
            return this.typeTitle;
        if (!this.type)
            return undefined;
        const settingRef = network_constants_1.NetworkConstants.SETTING_LAB_SAMPLE_TYPE;
        const setting = (_a = this.context) === null || _a === void 0 ? void 0 : _a.settingsMap.get(settingRef);
        if (!this.context || !setting)
            return this.type ? this.type : undefined;
        const quality = setting.values.find(el => el.identifier == this.type);
        if (!quality)
            return this.type ? this.type : undefined;
        return quality.title ? quality.title : this.type ? this.type : undefined;
    }
    searchFilter(filter) {
        const str = `${this.materialID}${this.type}${this.getTypeTitle()}`.toLowerCase();
        return str.includes(filter);
    }
    /**
     * Function for skipping objects and data while deepcopying class.
     * used as optional Input for deepCopy(any, replacerFn)
     * @param key
     */
    replacerFn(key) {
        const list = ["context", "districts"];
        if (list.includes(key))
            return false;
        else
            return true;
    }
}
exports.LaboratorySample = LaboratorySample;
